import { useSearchParams } from 'next/navigation'
import React from 'react'

import { useLocalStorage } from './useLocalStorage'

export const useAnalytics = () => {
  return useLocalStorage('gyym:AnalyticsParams', {
    utmSource: undefined as string | undefined,
    utmMedium: undefined as string | undefined,
    utmCampaign: undefined as string | undefined,
  })
}

export const useAnalyticsParams = () => {
  const searchParams = useSearchParams()
  const [storedParams] = useAnalytics()

  return {
    utmSource: searchParams?.get('utm_source') ?? storedParams.utmSource,
    utmMedium: searchParams?.get('utm_medium') ?? storedParams.utmMedium,
    utmCampaign: searchParams?.get('utm_campaign') ?? storedParams.utmCampaign,
  }
}

export const useAnalyticsTrackingEffect = () => {
  const searchParams = useSearchParams()
  const [, setStoredParams] = useAnalytics()

  const hasParams =
    searchParams?.has('utm_campaign') ||
    searchParams?.has('utm_medium') ||
    searchParams?.has('utm_source')

  React.useEffect(() => {
    if (!hasParams) return

    const newParams = {
      utmSource: searchParams?.get('utm_source') ?? undefined,
      utmMedium: searchParams?.get('utm_medium') ?? undefined,
      utmCampaign: searchParams?.get('utm_campaign') ?? undefined,
    }

    setStoredParams(newParams)
  }, [hasParams, searchParams, setStoredParams])
}
